import { apiClientChatting } from '@/utils/axios'

import type { SentMediaMessage, SentMediaMessageResponse } from '../types'

const getSentMediaMessages = (
  creatorId: number,
  fanId: number,
): Promise<SentMediaMessageResponse> => {
  return apiClientChatting
    .get(`/sent-media-messages/${creatorId}/${fanId}`)
    .then((res) => res.data)
}

const postMediaMessages = (
  creatorId: number,
  fanId: number,
  messages: SentMediaMessage[],
) => {
  return apiClientChatting
    .post(`/sent-media-messages/${creatorId}/${fanId}`, messages)
    .then((res) => res.data)
}

const setLastFetchedDate = (creatorId: number, date: string) => {
  return apiClientChatting
    .post(`/sent-media-messages/${creatorId}/last-fetched`, date)
    .then((res) => res.data)
}

export const sentMediaMessageService = {
  getSentMediaMessages,
  postMediaMessages,
  setLastFetchedDate,
}
